import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LegacyApp from './legacy/LegacyApp';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './new/context/ThemeContext';
import AuthGate from './auth/AuthGate';

// Code-split: nowa wersja ładowana leniwie (osobny chunk)
const NewApp = React.lazy(() => import('./new/NewApp'));

/**
 * Main App component with dual routing:
 * - / : Legacy version (original SimpleWISCVSystem)
 * - /new/* : New upgraded version with modern architecture
 */
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthGate>
      <BrowserRouter>
        <Routes>
          {/* Legacy route - preserves original functionality */}
          <Route
            path="/"
            element={
              <ErrorBoundary>
                <LegacyApp />
              </ErrorBoundary>
            }
          />

          {/* New version routes */}
          <Route
            path="/new/*"
            element={
              <ErrorBoundary>
                <Suspense
                  fallback={
                    <div className="min-h-screen flex items-center justify-center text-slate-600">
                      Ładowanie…
                    </div>
                  }
                >
                  <NewApp />
                </Suspense>
              </ErrorBoundary>
            }
          />
        </Routes>
      </BrowserRouter>
      </AuthGate>
    </ThemeProvider>
  );
};

export default App;
